import { AxiosResponse } from 'axios';
import { Team, UserTeam } from 'data/team/team.types';
import cloneDeep from 'lodash.clonedeep';

const buildTeamsMap = (teams: Team[]): {[key: string]: Team} => {

  return teams.reduce((total, actual) => ({
    ...total,
    [actual.id]: actual
  }), {} as {[key:string]: Team });
}

const filterUpdatedTeams = (teamsMap: {[key: string]: Team }) => (team: UserTeam): boolean => !team.id || teamsMap?.[team.id] != null;

const updateTeamName = (teamsMap: {[key: string]: Team }) => (team:UserTeam): UserTeam => {
  if (!team.id) {
    return team;
  }

  return ({
    ...team,
    name: teamsMap[team.id].name,
    cspid: teamsMap[team.id].cspid,
  })
}

/**
 * This fundtion will check if the uset theam was updated or even deleted and update user teams list
 * The function had to make some conditional because the default team called Unrestricted with  id = ""
 */
 const getExinstingUserTeams = (userTeams: UserTeam[], teams: Team[]): UserTeam[] => {

  const teamsMap = buildTeamsMap(teams);

  return userTeams
    .filter(filterUpdatedTeams(teamsMap))
    .map(updateTeamName(teamsMap));
}

/**
 * Function responsable for make sure team users are really updated according to server
 * @param teamsResponse
 * @param userTeamsResponse
 */
// eslint-disable-next-line import/prefer-default-export
export const adaptUserTeamsResponse = (userTeamsResponse: AxiosResponse<any>, teamsResponse: AxiosResponse<any>,) => {
  const teams = teamsResponse.data.data;
  const userTeams = userTeamsResponse.data.data;

  const clonedUserTeamsResponse = cloneDeep(userTeamsResponse);

  clonedUserTeamsResponse.data.data = getExinstingUserTeams(userTeams, teams);

  return Promise.resolve(clonedUserTeamsResponse);
}
